module.exports = __webpack_public_path__ + "img/recs_3.c4aa38c6.png";